import { render, staticRenderFns } from "./page-head.vue?vue&type=template&id=6b998a70&"
import script from "./page-head.vue?vue&type=script&lang=js&"
export * from "./page-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports